import Constants from '../Constants.js';
import GroupedListReducer from '../GroupedListReducer.js';
const resourceUser = GroupedListReducer.create({
  name: 'user',
  idKey: 'id',
  idActionKey: 'userId',
  constantPrefix: 'api.resourceUser',
  itemKey: 'user',
  itemsKey: 'items',
  defaultStateKey: 'resourceUsers',
  actionHandlers: (state, action, createState) => {
    switch (action.type) {
      case Constants.RESOURCE_USER_UPDATE_ROLES:
        {
          const {
            resourceId,
            userId,
            roles
          } = action;
          const nState = {
            ...state
          };
          nState[resourceId] = createState(state[resourceId], userId);
          nState[resourceId].users = nState[resourceId].users.map(user => {
            if (user.id === userId) {
              const nUser = {
                ...user,
                roles: roles || []
              };
              return nUser;
            }
            return user;
          });
          return nState;
        }
      default:
        return state;
    }
  }
});
export default resourceUser;